import "./OwRadioSelect.scss";
import IOwRadioSelectOption from "../../../models/IOwRadioSelectOption";
import ISupplierModel from "../../../models/ISupplierModel";
import OwInputWrapper from "../OwInputWrapper/OwInputWrapper";
import OwTranslate from "../OwTranslate/OwTranslate";

type Props = {
    supplierModel?: ISupplierModel;
    /**
     * An array of objects with a name and value property
     */
    options: IOwRadioSelectOption[];
    name: string;
    fn: (e: any) => void;
    defaultValue?: string;
    value?: string;
    translateUseLabel?: boolean;
    /** Locks every option (e.g. while the current choice is being saved). */
    disabled?: boolean;
};

const OwRadioSelect = (props: Props) => {
    return (
        <div className="OwRadioSelect">
            {props.options.map((option, index) => {
                return (
                    <div key={index}>
                        <label className={props.disabled ? "mb-0 text-muted" : "pointer mb-0"}>
                            <OwInputWrapper
                                className={"me-2"}
                                type={"radio"}
                                name={props.name}
                                value={option.value}
                                fn={props.fn}
                                disabled={props.disabled}
                                checked={props.value !== undefined ? props.value === option.value : props.defaultValue === option.value}
                            />
                            <OwTranslate
                                isSupplierVendorOverride={!!props.supplierModel?.vendor_name_override}
                                supplierModel={props.supplierModel}
                                defaultMessage={option.label}
                                id={props.translateUseLabel ? option.label : option.value}
                            />
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

export default OwRadioSelect;
